import { EnvironmentConfigModel } from './environment-config.service';

/**
 * uses customProps to add new configurations or override existing one
 */
export abstract class Environment {
  abstract readonly production: boolean;
  abstract readonly baseUrl: string;
  abstract readonly appName: string;
  abstract readonly serviceUrlList: ServiceUrlList;
  abstract readonly customProps?: any | EnvironmentConfigModel;
}
export interface UIAppsBaseURLs {
  apiOneExternal: string;
  tokenUrl: string;
}
export interface ServiceUrl {
  name: string;
  rootUrl: string;
}
export interface ServiceUrlList {
  [id: string]: string;
}